import config from "../configure/config";
import bigInt from "big-integer";
import Web3 from "web3";

import {
  ERROR,
  GET_BALANCES,
  GET_PUBLIC_PRESALE_INFO,
  GET_POOLS_SUMMARY,
  defaultFundingAddress,
  isSameAddress,
  ENVIRONMENT,
  tokens,
  buidlStatsUrl,
  fundingTokens,
} from "../constants";
import { api } from "../components/stake/api";

export const _getBUIDLPrice = async (callback, themeType) => {
  try {
    const url = buidlStatsUrl[themeType];
    const buidlStats = await api.get(url);
    console.log({ buidlStats });

    callback(null, buidlStats.data.buidlPrice);
  } catch (e) {
    console.error("Get BUIDL Price Error", e);
    callback(null);
    // callback(e);
  }
};

export const _getCirculatingSupply = async () => {
  try {
    const url =
      ENVIRONMENT === "mainnet"
        ? "https://base.api.starter.xyz/supply"
        : "https://test.base.api.starter.xyz/supply";

    const res = await api.get(url);
    return res.data;
  } catch (e) {
    console.error("Get Circulating Supply Error", e);
    return 0;
  }
};

export const _getPoolInfo = async (web3, pool, account, callback) => {
  let StarterContract = new web3.eth.Contract(pool.abi, pool.address);
  try {
    const withdrawLimit = await StarterContract.methods
      .withdrawalLimitPercent()
      .call({
        from: account.address,
      });
    const poolStructure = await StarterContract.methods
      .poolInfo(pool.poolIndex)
      .call({
        from: account.address,
      });
    const balanceOfPool = await StarterContract.methods
      .balanceOfPool(pool.poolIndex)
      .call({
        from: account.address,
      });
    callback(null, {
      withdrawLimit,
      balanceOfPool,
      ...poolStructure,
    });
  } catch (err) {
    console.error("_getPoolInfo error", err);
    return callback(err);
  }
};

export const _callClaimReward = async (
  store,
  dispatcher,
  emitter,
  presaleIndex,
  account,
  presaleType,
  callback
) => {
  const web3 = new Web3(store.getStore("web3context").library.provider);
  const presales = store.getStore("publicPresales");
  const factory = store.getStore("factory");
  const starterInfoContract = new web3.eth.Contract(
    factory.starterInfoAbi,
    factory.starterInfoAddress
  );
  const presale = presales[presaleIndex];
  let presaleAddress;
  if (presaleType === "private") {
    presaleAddress = presale.presaleAddress;
  } else {
    presaleAddress = await starterInfoContract.methods
      .getPresaleAddress(presaleIndex)
      .call();
  }
  const presaleContract =
    presaleType === "private"
      ? new web3.eth.Contract(presale.presaleAbi, presale.presaleAddress)
      : new web3.eth.Contract(
          _getPresaleAbiByBscsId(store, presaleIndex),
          presaleAddress
        );
  if (presaleContract.methods.claimTokens) {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .claimTokens()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  }
};

export const _callClaimHodler = async (
  store,
  dispatcher,
  emitter,
  account,
  callback
) => {
  const web3 = new Web3(store.getStore("web3context").library.provider);
  const factory = store.getStore("factory");

  const factoryContract = new web3.eth.Contract(
    factory.factoryV3Abi,
    factory.factoryV3Address
  );

  if (factoryContract.methods.claimHodlerFund) {
    const gasPrice = await web3.eth.getGasPrice();
    factoryContract.methods
      .claimHodlerFund()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
        }
      })
      .on("receipt", function (receipt) {
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  }
};

export const _getStakingPool = async (
  store,
  dispatcher,
  emitter,
  web3,
  callback
) => {
  const stakingTokenAddress = store.getStore("StakingToken");
  const contractAddress = store.getStore("StakedContractAddress");
  const stakingTokenName = store.getStore("StakingTokenName");
  try {
    const info = {
      address: contractAddress,
      name: stakingTokenName,
      tokenAddress: stakingTokenAddress,
    };
    callback(null, info);
  } catch (ex) {
    return callback(ex);
  }
};

export const _getFactoryPool = async (
  store,
  dispatcher,
  emitter,
  web3,
  callback
) => {
  const factory = store.getStore("factory");
  const stakedContractAddress = store.getStore("StakedContractAddress");
  const starterInfoAddress = store.getStore("StarterInfoAddress");

  const contractAbi = factory.factoryAbi;
  const contractAddress = factory.factoryAddress;

  let factoryContract = new web3.eth.Contract(contractAbi, contractAddress);
  try {
    const stakingPool = stakedContractAddress;
    const starterInfo = starterInfoAddress;
    const owner = await factoryContract.methods.owner().call();
    const pendingOwner = factoryContract.methods.pendingOwner
      ? await factoryContract.methods.pendingOwner().call()
      : "";
    const info = {
      address: contractAddress,
      stakingPool,
      starterInfo,
      owner,
      pendingOwner,
    };
    callback(null, info);
  } catch (ex) {
    return callback(ex);
  }
};

export const _getBnbBalance = async (
  store,
  dispatcher,
  emitter,
  web3,
  account,
  callback
) => {
  try {
    const balance =
      account && account.address
        ? await web3.eth.getBalance(account.address)
        : new bigInt();
    callback(null, bigInt(balance));
  } catch (er) {
    return callback(er);
  }
};

export const _getBUIDLBalance = async (
  store,
  dispatcher,
  emitter,
  web3,
  account,
  callback
) => {
  const tokenAbi = store.getStore("tokenAbi");
  const tokenAddress = store.getStore("tokenAddress");
  const themeType = store.getStore("themeType");

  let walletContract = new web3.eth.Contract(tokenAbi, tokenAddress);

  const stakingContractAbi = store.getStore("StakedContractAbi");
  const stakingContractAddress = store.getStore("StakedContractAddress");

  let stakingContract = new web3.eth.Contract(
    stakingContractAbi,
    stakingContractAddress
  );

  try {
    if (account && account.address) {
      let balance = await walletContract.methods
        .balanceOf(account.address)
        .call();
      const stakingContracts = config[themeType].stakingContracts;

      let totalStakedLocked = bigInt(0);
      for (let i = 0; i < stakingContracts.length; i++) {
        const amount = await walletContract.methods
          .balanceOf(stakingContracts[i])
          .call();
        totalStakedLocked += bigInt(amount);
      }

      let stakingTokenBalance = await stakingContract.methods
        .users(account.address)
        .call({
          from: account.address,
        });

      callback(null, {
        balance: bigInt(balance),
        stakingTokenBalance: bigInt(stakingTokenBalance.tokenAmount),
        totalStakedLocked,
      });
    } else {
      let balance = "0";
      const stakingContracts = config[themeType].stakingContracts;

      let totalStakedLocked = bigInt(0);
      for (let i = 0; i < stakingContracts.length; i++) {
        const amount = await walletContract.methods
          .balanceOf(stakingContracts[i])
          .call();
        totalStakedLocked += bigInt(amount);
      }
      let stakingTokenBalance = "0";

      callback(null, {
        balance: bigInt(balance),
        stakingTokenBalance: bigInt(stakingTokenBalance),
        totalStakedLocked,
      });
    }
  } catch (ex) {
    return callback(ex);
  }
};

export const _getStakedBalance = async (
  store,
  dispatcher,
  emitter,
  web3,
  account,
  callback
) => {
  const contractAbi = store.getStore("StakedContractAbi");
  const contractAddress = store.getStore("StakedContractAddress");
  const themeType = store.getStore("themeType");

  const starterInfoAbi = store.getStore("StarterInfoAbi");
  const starterInfoAddress = store.getStore("StarterInfoAddress");

  let stakedContract = new web3.eth.Contract(contractAbi, contractAddress);
  let starterContract = new web3.eth.Contract(
    starterInfoAbi,
    starterInfoAddress
  );
  try {
    if (account && account.address) {
      let stakedInfo = await stakedContract.methods
        .users(account.address)
        .call({
          from: account.address,
        });

      const minCreatorStakedBalance = await starterContract.methods
        .getMinCreatorStakedBalance(defaultFundingAddress[themeType])
        .call({
          from: account.address,
        });

      stakedInfo.totalStakedBalance = stakedInfo.tokenAmount;

      // try {
      //   stakedInfo.totalStakedBalance = await starterContract.methods
      //     .getStaked(stakingTokenAddress, account.address)
      //     .call();
      // } catch (error) {
      //   stakedInfo.totalStakedBalance = stakedInfo.tokenAmount;
      // }

      let isLongStaker = await stakedContract.methods
        .isLongStaker(account.address)
        .call({
          from: account.address,
        });

      let burnFee = await stakedContract.methods
        .getTokenBurnFee(account.address)
        .call({
          from: account.address,
        });

      let minStakeTime = await starterContract.methods.getMinStakeTime().call();

      let minUnstakeTime = await starterContract.methods
        .getMinUnstakeTime()
        .call();

      let isCertifiedAllowed = await starterContract.methods
        .getPresaleCreatorDev(account.address)
        .call();

      const info = {
        v1Balance: 0,
        balance: bigInt(stakedInfo.balance),
        minCreatorStakedBalance: bigInt(minCreatorStakedBalance) || 0,
        isCertifiedAllowed: isCertifiedAllowed,
        totalStakedBalance: bigInt(stakedInfo.totalStakedBalance),
        lastStakedTime: parseInt(stakedInfo.lastStakedTimestamp) || 0,
        lastUnstakedTime: parseInt(stakedInfo.lastUnstakedTimestamp) || 0,
        lastInvestTimestamp: parseInt(stakedInfo.lastInvestTimestamp) || 0,
        minStakeTime: parseInt(minStakeTime),
        minUnstakeTime: parseInt(minUnstakeTime),
        firstStakedTimestamp: parseInt(stakedInfo.firstStakedTimestamp),
        isLongStaker,
        burnFee: parseInt(burnFee) / 100,
      };
      return callback(null, info);
    } else {
      let minStakeTime = await starterContract.methods.getMinStakeTime().call();
      let minUnstakeTime = await starterContract.methods
        .getMinUnstakeTime()
        .call();

      const info = {
        v1Balance: bigInt(),
        balance: bigInt(),
        minCreatorStakedBalance: bigInt(),
        isCertifiedAllowed: false,
        totalStakedBalance: bigInt(),
        lastStakedTime: 0,
        lastUnstakedTime: 0,
        lastInvestTimestamp: 0,
        minStakeTime: parseInt(minStakeTime),
        minUnstakeTime: parseInt(minUnstakeTime),
        firstStakedTimestamp: 0,
        isLongStaker: false,
        burnFee: 50,
      };
      callback(null, info);
    }
  } catch (ex) {
    callback(ex);
  }
};

export const _getMinCreatorStakedBalance = async (
  store,
  web3,
  account,
  fundingAddress
) => {
  const starterInfoAbi = store.getStore("StarterInfoAbi");
  const starterInfoAddress = store.getStore("StarterInfoAddress");

  let starterContract = new web3.eth.Contract(
    starterInfoAbi,
    starterInfoAddress
  );

  const minCreatorStakedBalance = await starterContract.methods
    .getMinCreatorStakedBalance(fundingAddress)
    .call({
      from: account.address,
    });

  return minCreatorStakedBalance;
};

export const _getSwapData = async (store, web3, account) => {
  const themeType = store.getStore("themeType");
  const buidlTokenAddress = store.getStore("tokenAddress");
  const swapData = store.getStore("swapData");

  const swapTokenContract = new web3.eth.Contract(
    swapData.swapTokenAbi,
    swapData.swapTokenAddress
  );
  const swapRouterContract = new web3.eth.Contract(
    swapData.swapRouterAbi,
    swapData.swapRouterAddress
  );
  const path = [swapData.swapTokenAddress, buidlTokenAddress];
  if (account && account.address) {
    const swapTokenBalance =
      swapData.swapTokenAddress ===
      fundingTokens[themeType].find((token) => token.label === "ETH").value
        ? await web3.eth.getBalance(account.address)
        : await swapTokenContract.methods.balanceOf(account.address).call();

    const amountsOut = await swapRouterContract.methods
      .getAmountsOut("1000000", path) // todo: change the decimals accordinly (6 and 18)
      .call();

    const swapPrice = amountsOut[1];
    const info = {
      ...swapData,
      swapTokenBalance: bigInt(swapTokenBalance),
      swapPrice: bigInt(swapPrice),
      swapTokenDecimals: fundingTokens[themeType].find(
        (token) => token.label === swapData.swapSymbol
      ).decimals,
    };

    return info;
  } else {
    const swapTokenBalance = bigInt();

    const amountsOut = await swapRouterContract.methods
      .getAmountsOut("1000000", path)
      .call();
    const swapPrice = amountsOut[1];
    const info = {
      ...swapData,
      swapTokenBalance: bigInt(swapTokenBalance),
      swapPrice: bigInt(swapPrice),
    };
    return info;
  }
};

export const _callSwap = async (
  store,
  dispatcher,
  emitter,
  web3,
  account,
  swapRouterContract,
  path,
  inputToken,
  outputToken,
  amount,
  amountOut,
  callback
) => {
  try {
    const themeType = store.getStore("themeType");
    const timestamp = parseInt(Date.now() / 1000);
    const gasPrice = await web3.eth.getGasPrice();
    if (
      web3.utils.toChecksumAddress(inputToken) ===
      web3.utils.toChecksumAddress(
        fundingTokens[themeType].find((token) => token.label === "ETH").value
      )
    ) {
      if (swapRouterContract.methods.swapExactETHForTokens) {
        swapRouterContract.methods
          .swapExactETHForTokens(
            amountOut,
            path,
            account.address,
            timestamp + 600
          )
          .send({
            from: account.address,
            value: amount,
            gasPrice,
          })
          .on("transactionHash", function (hash) {
            console.log(hash);
          })
          .on("confirmation", function (confirmationNumber, receipt) {
            if (confirmationNumber === 3) {
              dispatcher.dispatch({
                type: GET_BALANCES,
                content: {},
              });
            }
          })
          .on("receipt", function (receipt) {
            callback(null, receipt.transactionHash);
          })
          .on("error", function (error) {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          })
          .catch((error) => {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          });
      } else if (swapRouterContract.methods.swapExactAVAXForTokens) {
        swapRouterContract.methods
          .swapExactAVAXForTokens(
            amountOut,
            path,
            account.address,
            timestamp + 600
          )
          .send({
            from: account.address,
            value: amount,
            gasPrice,
          })
          .on("transactionHash", function (hash) {
            console.log(hash);
          })
          .on("confirmation", function (confirmationNumber, receipt) {
            if (confirmationNumber === 3) {
              dispatcher.dispatch({
                type: GET_BALANCES,
                content: {},
              });
            }
          })
          .on("receipt", function (receipt) {
            callback(null, receipt.transactionHash);
          })
          .on("error", function (error) {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          })
          .catch((error) => {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          });
      }
    } else if (
      web3.utils.toChecksumAddress(outputToken) ===
      web3.utils.toChecksumAddress(
        fundingTokens[themeType].find((token) => token.label === "ETH").value
      )
    ) {
      if (swapRouterContract.methods.swapExactTokensForETH) {
        swapRouterContract.methods
          .swapExactTokensForETH(
            amount,
            amountOut,
            path,
            account.address,
            timestamp + 600
          )
          .send({
            from: account.address,
            gasPrice,
          })
          .on("transactionHash", function (hash) {
            console.log(hash);
          })
          .on("confirmation", function (confirmationNumber, receipt) {
            if (confirmationNumber === 3) {
              dispatcher.dispatch({
                type: GET_BALANCES,
                content: {},
              });
            }
          })
          .on("receipt", function (receipt) {
            callback(null, receipt.transactionHash);
          })
          .on("error", function (error) {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          })
          .catch((error) => {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          });
      } else if (swapRouterContract.methods.swapExactTokensForAVAX) {
        swapRouterContract.methods
          .swapExactTokensForAVAX(
            amount,
            amountOut,
            path,
            account.address,
            timestamp + 600
          )
          .send({
            from: account.address,
            gasPrice,
          })
          .on("transactionHash", function (hash) {
            console.log(hash);
          })
          .on("confirmation", function (confirmationNumber, receipt) {
            if (confirmationNumber === 3) {
              dispatcher.dispatch({
                type: GET_BALANCES,
                content: {},
              });
            }
          })
          .on("receipt", function (receipt) {
            callback(null, receipt.transactionHash);
          })
          .on("error", function (error) {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          })
          .catch((error) => {
            if (!error.toString().includes("-32601")) {
              if (error.message) {
                return callback(error.message);
              }
              callback(error);
            }
          });
      }
    } else {
      swapRouterContract.methods
        .swapExactTokensForTokens(
          amount,
          amountOut,
          path,
          account.address,
          timestamp + 600
        )
        .send({
          from: account.address,
          gasPrice,
        })
        .on("transactionHash", function (hash) {
          console.log(hash);
        })
        .on("confirmation", function (confirmationNumber, receipt) {
          if (confirmationNumber === 3) {
            dispatcher.dispatch({
              type: GET_BALANCES,
              content: {},
            });
          }
        })
        .on("receipt", function (receipt) {
          callback(null, receipt.transactionHash);
        })
        .on("error", function (error) {
          if (!error.toString().includes("-32601")) {
            if (error.message) {
              return callback(error.message);
            }
            callback(error);
          }
        })
        .catch((error) => {
          if (!error.toString().includes("-32601")) {
            if (error.message) {
              return callback(error.message);
            }
            callback(error);
          }
        });
    }
  } catch (error) {
    console.error("_callSwap", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callApply = async (
  store,
  dispatcher,
  emitter,
  web3,
  factoryContract,
  account,
  bscPresaleInfo,
  presalePancakeSwapInfo,
  presaleStringInfo,
  auditInfo,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();

    factoryContract.methods
      .createPresale(
        bscPresaleInfo,
        presalePancakeSwapInfo,
        presaleStringInfo,
        auditInfo
      )
      .send({
        from: account.address,
        gasPrice,
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 2) {
          dispatcher.dispatch({
            type: GET_POOLS_SUMMARY,
            content: {},
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(
          receipt,
          receipt.events.PresaleCreated.returnValues.starterId
        );
        callback(null, receipt.events.PresaleCreated.returnValues.starterId);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    callback(error);
  }
};

export const _checkAllowance = async (
  store,
  abi,
  address,
  account,
  amount,
  contract
) => {
  try {
    const web3 = new Web3(store.getStore("web3context").library.provider);
    const erc20Contract = new web3.eth.Contract(abi, address);

    if (!erc20Contract.methods.allowance) {
      return true; // Doesn't need approval
    }
    const allowance = await erc20Contract.methods
      .allowance(account.address, contract)
      .call({
        from: account.address,
      });

    return !bigInt(allowance).lesser(amount);
  } catch (error) {
    if (error.message) {
      return false;
    }
    return false;
  }
};

export const _checkApproval = async (
  store,
  dispatcher,
  emitter,
  abi,
  address,
  account,
  amount,
  contract
) => {
  try {
    const web3 = new Web3(store.getStore("web3context").library.provider);
    const erc20Contract = new web3.eth.Contract(abi, address);

    if (!erc20Contract.methods.allowance) {
      return true; // Doesn't need approval
    }
    const allowance = await erc20Contract.methods
      .allowance(account.address, contract)
      .call({
        from: account.address,
      });

    if (bigInt(allowance).lesser(amount)) {
      const gasPrice = await web3.eth.getGasPrice();

      const gas = await erc20Contract.methods
        .approve(contract, amount)
        .estimateGas({
          from: account.address,
          gasPrice,
        });
      await erc20Contract.methods.approve(contract, amount).send({
        from: account.address,
        gas,
        gasPrice,
      });
    }
    return true;
  } catch (error) {
    if (error.message) {
      return false;
    }
    return false;
  }
};

export const _signMessage = async (store, account, message) => {
  try {
    const web3 = new Web3(store.getStore("web3context").library.provider);

    const signature = await web3.eth.personal.sign(
      message,
      account.address,
      ""
    );

    // split signature
    const r = signature.slice(0, 66);
    const s = "0x" + signature.slice(66, 130);
    const v = parseInt(signature.slice(130, 132), 16);

    console.log("account.address", account.address);
    console.log("message", message);
    console.log("Signature:", signature);
    console.log("r:", r);
    console.log("s:", s);
    console.log("v:", v);
    console.log("test:", [signature, v, r, s]);

    return [signature, v, r, s];
  } catch (error) {
    console.error("Signature ERROR", error);
    if (error.message) {
      return [undefined];
    }
    return [undefined];
  }
};

export const _callVote = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  voteType,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .vote(voteType)
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("VOTE ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callUnstake = async (
  store,
  dispatcher,
  emitter,
  web3,
  stakingContract,
  amount,
  tokenAddress,
  account,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();

    stakingContract.methods
      .unstake(tokenAddress, amount)
      .send({
        from: account.address,
        gasPrice,
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 2) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.log("_callUnstake error", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callUnstakeV1 = async (
  store,
  dispatcher,
  emitter,
  web3,
  stakingContract,
  amount,
  tokenAddress,
  account,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();

    stakingContract.methods
      .unstake(tokenAddress, amount)
      .send({
        from: account.address,
        gasPrice,
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 2) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.log("_callUnstake error", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callMigrate = async (
  store,
  dispatcher,
  emitter,
  web3,
  stakingContract,
  tokenAddress,
  amount,
  account,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();

    stakingContract.methods
      .stake(tokenAddress, amount)
      .send({
        from: account.address,
        gasPrice,
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 2) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.log("_callStake error", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callStake = async (
  store,
  dispatcher,
  emitter,
  web3,
  stakingContract,
  amount,
  stakingToken,
  account,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();

    stakingContract.methods
      .stake(stakingToken, amount)
      .send({
        from: account.address,
        gasPrice,
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 2) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.log("_callStake error", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callLockLiquidity = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .addLiquidityAndLockLPTokens()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("LOCK_LIQUIDITY ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callGetRefund = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .getRefund()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("GET_REFUND ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callInvest = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  presaleType,
  fundingTokenAddress,
  amount,
  disclaimer,
  v,
  r,
  s,
  callback
) => {
  const gasPrice = await web3.eth.getGasPrice();

  console.log({ amount, disclaimer, v, r, s });

  try {
    const ethAddress = "0x4200000000000000000000000000000000000006";

    if (isSameAddress(fundingTokenAddress, tokens[ethAddress])) {
      presaleContract.methods
        .invest(amount)
        .send({
          from: account.address,
          value: amount,
          gasPrice,
        })
        .on("transactionHash", function (hash) {
          console.log(hash);
        })
        .on("confirmation", function (confirmationNumber, receipt) {
          if (confirmationNumber === 3) {
            dispatcher.dispatch({
              type: GET_BALANCES,
              content: {},
            });
            if (presaleType === "private") {
              dispatcher.dispatch({
                type: GET_PUBLIC_PRESALE_INFO,
                content: {
                  presaleIndex,
                },
              });
            } else {
              dispatcher.dispatch({
                type: GET_PUBLIC_PRESALE_INFO,
                content: {
                  presaleIndex,
                },
              });
            }
          }
        })
        .on("receipt", function (receipt) {
          console.log(receipt);
          callback(null, receipt.transactionHash);
        })
        .on("error", function (error) {
          if (!error.toString().includes("-32601")) {
            if (error.message) {
              return callback(error.message);
            }
            callback(error);
          }
        })
        .catch((error) => {
          if (!error.toString().includes("-32601")) {
            if (error.message) {
              return callback(error.message);
            }
            callback(error);
          }
        });
    } else {
      presaleContract.methods
        .invest(amount)
        .send({
          from: account.address,
          gasPrice,
        })
        .on("transactionHash", function (hash) {
          console.log(hash);
        })
        .on("confirmation", function (confirmationNumber, receipt) {
          if (confirmationNumber === 3) {
            dispatcher.dispatch({
              type: GET_BALANCES,
              content: {},
            });
            if (presaleType === "private") {
              dispatcher.dispatch({
                type: GET_PUBLIC_PRESALE_INFO,
                content: {
                  presaleIndex,
                },
              });
            } else {
              dispatcher.dispatch({
                type: GET_PUBLIC_PRESALE_INFO,
                content: {
                  presaleIndex,
                },
              });
            }
          }
        })
        .on("receipt", function (receipt) {
          console.log(receipt);
          callback(null, receipt.transactionHash);
        })
        .on("error", function (error) {
          if (!error.toString().includes("-32601")) {
            if (error.message) {
              return callback(error.message);
            }
            callback(error);
          }
        })
        .catch((error) => {
          if (!error.toString().includes("-32601")) {
            if (error.message) {
              return callback(error.message);
            }
            callback(error);
          }
        });
    }
  } catch (error) {
    console.error("INVEST ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callAllowClaim = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .allowClaim()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("ALLOW_CLAIM ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callSendUnSoldTokens = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .sendUnsoldTokens()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("SEND_UNSOLD_TOKENS ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callCancelPresale = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .cancelAndTransferTokensToPresaleCreator()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log({ receipt });
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("CANCEL_PRESALE ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callCollectFunds = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods
      .collectFundsRaised()
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          dispatcher.dispatch({
            type: GET_PUBLIC_PRESALE_INFO,
            content: {
              presaleIndex,
            },
          });
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("COLLECT_FUND ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _callWrite = async (
  store,
  dispatcher,
  emitter,
  web3,
  presaleContract,
  account,
  presaleIndex,
  method,
  args,
  callback
) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    presaleContract.methods[method](...args)
      .send({
        from: account.address,
        gasPrice,
      })
      .on("transactionHash", function (hash) {
        console.log(hash);
      })
      .on("confirmation", function (confirmationNumber, receipt) {
        if (confirmationNumber === 3) {
          dispatcher.dispatch({
            type: GET_BALANCES,
            content: {},
          });
          if (presaleIndex > 0) {
            dispatcher.dispatch({
              type: GET_PUBLIC_PRESALE_INFO,
              content: {
                presaleIndex,
              },
            });
          }
          callback(null, receipt);
        }
      })
      .on("receipt", function (receipt) {
        console.log(receipt);
        callback(null, receipt.transactionHash);
      })
      .on("error", function (error) {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      })
      .catch((error) => {
        if (!error.toString().includes("-32601")) {
          if (error.message) {
            return callback(error.message);
          }
          callback(error);
        }
      });
  } catch (error) {
    console.error("WRITE ERROR", error);
    return emitter.emit(ERROR, error);
  }
};

export const _getPresaleAbiByBscsId = (store, id) => {
  const factory = store.getStore("factory");

  return factory.presaleAbi;
};

export const _getPresaleAbiByVersion = (store) => {
  const factory = store.getStore("factory");
  return factory.presaleAbi;
};
